import { Helmet } from "react-helmet";
import { SideBar } from "../side-bar/SideBar";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { months } from "../../../utils/time.date.utlis";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight, faMagnifyingGlass, faTimes, faUserTie, faUserTag, faIdCard, faCheck,faFileArrowDown, faSpinner, faBoxArchive } from "@fortawesome/free-solid-svg-icons";
import { faSquareCheck } from "@fortawesome/free-regular-svg-icons";
import { api, getToken } from "../../../services/apis/auth-api/apiUrl";
import { 
    MONTHLY_ROLE_REQUIREMENTS,
    DOWNLOAD_CSV_REQUIREMENTS,
    SOFT_DELETE_END_POINT
} from "../../../config/config";
import { requirementsProps, filterItemsProps } from "../../../utils/types";
import Modal from "../modal/modal";
//import ViewRequirememtsDetails from "../modal/jdl-modals/role-requirements/viewRoleDetails";
import RoleFilter from "../modal/jdl-modals/role-requirements/RoleFilter";
import RolesMatched from "../modal/jdl-modals/role-requirements/RolesMatched";
import UploadOptions from "../modal/jdl-modals/role-requirements/UploadOptions";

interface requirementsStatProps {
    clients : {active_num : number, stat : string};
    fte : {fte_num : number, stat : string};
    roles : {role_num : number, stat : string};
}

interface segProps {
    seg : string;
    checked : boolean;
}

interface extendedReqProps extends requirementsProps {
    checked : boolean;
}

interface rolesMatchedProps {
    id: number; 
    position_title : string; 
    client_name : string;
    matched_skills : number; 
    matched_cert: number; 
    matched_percentage : number;
}

export default function RoleRequirements () {
    const date = new Date();
    const currentYear = date.getFullYear();
    const currentMonth = date.getMonth();

    const [year, setYear] = useState<number>(currentYear);
    const [month, setMonth] = useState<number>(currentMonth);
    const [reqSearch, setReqSearch] = useState<string>('');
    const [positionSearch, setPositionSearch] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(true);
    const [monthRoles, setMonthRoles] = useState<requirementsProps[]>([]);

    const [filteredRoles, setFilteredRoles] = useState<extendedReqProps[]>([]);
    const [statistics, setStatistics] = useState<requirementsStatProps>();
    const allRoles = useRef<HTMLInputElement | null>(null);
    const divFloatCard = useRef<HTMLDivElement | null>(null);
    const _divFloatCard = useRef<HTMLDivElement | null>(null);

    //Filter
    const [filterItems, setFilterItems] = useState<filterItemsProps>({
        domains : [],
        shift_shed : [],
        clients : [],
        status : [],
        cl : []
    });
    const [showAll, setShowAll] = useState<boolean>(true);
    const [segments, setSegments] = useState<segProps[] | null>(null);
    const [subSegments, setSubSegments] = useState<segProps[] | null>(null);

    //float card control
    const [showAvailSeg, setShowAvailSeg] = useState<boolean>(false);
    const [showAvailSubSeg, setShowAvailSubSeg] = useState<boolean>(false);
    
    //Modal
    const [showModal, setShowModal] = useState<boolean>(false);
    const [modalChildren, setModalChildren] = useState<React.JSX.Element | null>(null);
    const [fileDownloading, setFileDownloading] = useState<boolean>(false);
    const [archiveBtnLoading, setArchiveBtnLoading] = useState<boolean>(false);
    const [idsUpdated, setidsUpdated] = useState<number[]>([]);

    const [rolesMatched, setRolesMatched] = useState<rolesMatchedProps[] | null>(null);
    const [cv_name, setCvName] = useState<string>('');

    useEffect(()=>{
        if(rolesMatched !== null && cv_name !== ''){
            setModalChildren(<RolesMatched roles={rolesMatched} name={cv_name} />)
        }
    }, [rolesMatched, cv_name])

    useEffect(()=>{
        const filteredRolesMonthly : requirementsProps[] = [];
        setLoading(true);
        if(positionSearch === '' && !showAll){
            monthRoles.forEach((role)=>{
                const date = role.date_updated.split(' ');
                const splitDate = date[0].split('-');
                const _year = parseInt(splitDate[0]);
                const _month =parseInt(splitDate[1]);
    
                if(year === _year && (month + 1) === _month){
                    filteredRolesMonthly.push(role);
                }
            });
            
            setFilteredRoles(filteredRolesMonthly.map(role => ({...role, checked : false})));
        }
        setLoading(false);

    },[month, monthRoles, positionSearch, showAll, year]);

    useEffect(()=>{
        if(positionSearch !== ''){
            const filteredPosition = monthRoles.filter(role => 
                role.position_title.toLowerCase().includes(positionSearch.toLowerCase())
            )
            setFilteredRoles(filteredPosition.map(role => ({...role, checked : false})));
        }
        setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[positionSearch]);

    useEffect(()=>{
        setLoading(true);
        if(showAll){
            setFilteredRoles(monthRoles.map(role => ({...role, checked : false})));
        }
        setLoading(false);
    },[monthRoles, showAll]);

    useEffect(()=>{
        if(segments && subSegments){
            const selected_seg = segments.some(seg => seg.checked);
            const selected_sub_seg = subSegments.some(sub => sub.checked);

            if(selected_seg || selected_sub_seg) { 
                setLoading(true);
                const filteredMonthRoles = monthRoles.filter((role)=>
                    segments.some(seg => seg.seg === role.segment_name && seg.checked) ||
                    subSegments.some(sub_seg => sub_seg.seg === role.sub_segment_name && sub_seg.checked)
                );
    
                setFilteredRoles(filteredMonthRoles.map(role => ({...role, checked : false})));
            }
            setLoading(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [segments, subSegments])

    useEffect(()=>{
        setLoading(true);

        const getRoles = async() => {
            const roles_data = await api.post(MONTHLY_ROLE_REQUIREMENTS, filterItems, {
                headers: { 'Authorization': 'Bearer ' + getToken() }
            });

            const roles : requirementsProps[] = roles_data.data.monthly_req;
            const stat : requirementsStatProps = roles_data.data.stat;

            const segArr : segProps[] = [];
            const subSegArr : segProps[] = [];
            
            roles.forEach((role)=>{
                const segInserted = segArr.some((seg)=> seg.seg === role.segment_name);
                const subSegInserted = subSegArr.some((seg)=> seg.seg === role.sub_segment_name);
                
                if(!segInserted) segArr.push({ seg : role.segment_name, checked : false});
                if(!subSegInserted) subSegArr.push({ seg : role.sub_segment_name, checked : false});
            })

            setMonthRoles(roles);
            setStatistics(stat);
            setSegments(segArr);
            setSubSegments(subSegArr);
            setShowAll(true);
            setFilteredRoles(roles.map(role => ({...role, checked : false})));
            setLoading(false);
        }
        getRoles();
    },[filterItems, idsUpdated]);

    const checkSelected = (seg : segProps[]) => {
        const someSelected = seg.some(seg => seg.checked);
        if(!someSelected) setFilteredRoles([]);
    }

    const selectSeg = (segment : string, event : ChangeEvent<HTMLInputElement>) => {
        setLoading(true);
        setShowAll(false);
        const isChecked = event.currentTarget.checked;
        if(segments){
            const updatedSeg = segments.map((seg_name)=>
                seg_name.seg === segment ? {...seg_name, checked : isChecked} : seg_name
            );
            setSegments(updatedSeg);
            checkSelected(updatedSeg);
        }
    }

    const handleSelectAllSeg = (select : boolean) => {
        setLoading(true);
        setShowAll(false);
        if(segments){
            const updatedSeg = segments.map((seg_name)=> ({...seg_name, checked : select}));
            setSegments(updatedSeg);
            checkSelected(updatedSeg);
        }
    }

    const selectSubSeg = (sub_segment : string, event : ChangeEvent<HTMLInputElement>) => {
        setLoading(true);
        setShowAll(false);
        const isChecked = event.currentTarget.checked;
        if(subSegments){
            const updatedSubSeg = subSegments.map((seg_name)=>
                seg_name.seg === sub_segment ? {...seg_name, checked : isChecked} : seg_name
            );
            setSubSegments(updatedSubSeg);
            checkSelected(updatedSubSeg); 
        }
    }

    const handleSelectAllSubSeg = (select : boolean) => {
        setLoading(true);
        setShowAll(false);
        if(subSegments){
            const updatedSeg = subSegments.map((seg_name)=> ({...seg_name, checked : select}));
            setSubSegments(updatedSeg);
            checkSelected(updatedSeg);
        }
    }

    //1 = Segment button, 2 = Sub segment button
    const handleCloseFloatCard = (id : number) => {
        if(id === 1){
            setShowAvailSeg(showAvailSeg ? false : true);
            setShowAvailSubSeg(false);
        }else{
            setShowAvailSubSeg(showAvailSubSeg ? false : true);
            setShowAvailSeg(false);
        }
    }

    const handleClickOutside = (event: MouseEvent) => {
        if (
            !(_divFloatCard.current?.contains(event.target as Node)) &&
            !(divFloatCard.current?.contains(event.target as Node))
        ) {
          setShowAvailSeg(false);
          setShowAvailSubSeg(false);
        }
      };
    
      useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, []);

    const createModalContent = (content : React.JSX.Element) =>{
        setModalChildren(content);
        setShowModal(true);
    }

    const incrementYear = () => { 
        setYear(prevYear => prevYear + 1)
        setPositionSearch('');
        setShowAll(false);
        setLoading(true);
    };

    const decrementYear = () => {
        setYear(prevYear => prevYear - 1)
        setPositionSearch('');
        setShowAll(false);
        setLoading(true);
    };

    const incrementMonth = () => {
        setMonth(prevMonth => (prevMonth + 1) % 12);
        if (month === 11) incrementYear();
        setPositionSearch('');
        setShowAll(false);
        setLoading(true);
    };

    const decrementMonth = () => {
        setMonth(prevMonth => (prevMonth === 0 ? 11 : prevMonth - 1));
        if (month === 0) decrementYear();
        setPositionSearch('');
        setShowAll(false);
        setLoading(true);
    };

    const handleFilter = (filter : filterItemsProps) =>{
        setShowModal(false);
        setFilterItems(filter);
    }

    const handleDownloadCsv = async() => {
        const filteredSelectedReq = filteredRoles.filter(role => role.checked).map(req => req.id);
        const timestamp = Date.now();
        const filename = `requirements_${timestamp}.csv`;
        setFileDownloading(true);
        try{
            const dl_response = await api.post(
                DOWNLOAD_CSV_REQUIREMENTS,
                {ids : filteredSelectedReq, file_name : filename},
                {
                    responseType : 'blob',
                    headers : {'Authorization' : 'Bearer '+ getToken()}
                }
            );

            const url = window.URL.createObjectURL(new Blob([dl_response.data], {type : 'text/csv'}));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            setFileDownloading(false);
        }catch(e){
            alert('Error downloading csv file');
            setFileDownloading(false);
        }
    }

    const handleSoftDel = async() => {
        setArchiveBtnLoading(true);
        const filteredSelectedReq = filteredRoles.filter(role => role.checked).map(req => req.id);
        try{
            await api.patch(SOFT_DELETE_END_POINT, {
                ids : filteredSelectedReq
            },{
                headers : {'Authorization' : 'Bearer '+ getToken()}
            })
            setArchiveBtnLoading(false);
        }catch(e){
            alert('Error archiving roles');
            setArchiveBtnLoading(false);
        }
        setidsUpdated(filteredSelectedReq);
    }
    
    return(
        <div className='content flex'>
            <Helmet>
                <title>Requirements</title>
            </Helmet>
            <SideBar />
            <div className='main-content py-4'>
                <div className=" w-full flex flex-col gap-2 bg-white shadow p-2 mb-2">
                    <div className="flex justify-center items-center w-full">
                        <div className="hidden">
                            <div className="relative">
                                <input type="text" value={reqSearch} onChange={(e)=>setReqSearch(e.target.value)} className='text-box min-w-96' placeholder="Search requirements...." />
                                <div onClick={()=>setReqSearch('')} className={reqSearch !== '' ? "absolute top-2 right-2 cursor-pointer" : "hidden"}>
                                    <FontAwesomeIcon className="text-red-500" icon={faTimes} />
                                </div>
                            </div>
                        </div>
                        <div className="ms-auto flex gap-4 justify-center items-center">
                            
                            <div>
                                <button 
                                    onClick={()=>createModalContent(<RoleFilter onFilter={(filter)=> handleFilter(filter)} filters={filterItems} />)}
                                    type="button"
                                    className="button button-vcc-green text-sm"
                                    >
                                    <FontAwesomeIcon icon={faSquareCheck} /> &nbsp;
                                    Role Filter
                                </button>
                            </div>
                            <div>
                                <button type="button" onClick={()=>createModalContent(<UploadOptions callback_roles={(roles_matched)=> setRolesMatched(roles_matched)} callback_name={(name) => setCvName(name)} />)} className="button cursor-pointer button-vcc-primary text-sm">
                                    <FontAwesomeIcon icon={faMagnifyingGlass} /> &nbsp;
                                    CV Job finder
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="my-4 flex gap-20 w-full">

                        <div className="card-stat">
                            <div className="side-border" />
                            <div className="card-icon-container">
                                <div className="card-icon">
                                    <FontAwesomeIcon icon={faUserTie} />
                                </div>
                            </div>
                            <div className="card-details">
                                <div className="card-data">
                                    <div className="card-number">
                                       {statistics?.clients.active_num}
                                    </div>
                                </div>
                                <div className="card-label">Total active clients</div>
                            </div>
                            <div className="card-rate">
                                {statistics?.clients.stat}
                            </div>
                        </div>
                        
                        <div className="card-stat">
                            <div className="side-border" />
                            <div className="card-icon-container">
                                <div className="card-icon">
                                    <FontAwesomeIcon icon={faUserTag} />
                                </div>
                            </div>
                            <div className="card-details">
                                <div className="card-data">
                                    <div className="card-number">{statistics?.fte.fte_num}</div>
                                </div>
                                <div className="card-label">Total active FTEs</div>
                            </div>
                            <div className="card-rate">{statistics?.fte.stat}</div>
                        </div>

                        <div className="card-stat">
                            <div className="side-border" />
                            <div className="card-icon-container">
                                <div className="card-icon">
                                    <FontAwesomeIcon icon={faIdCard} />
                                </div>
                            </div>
                            <div className="card-details">
                                <div className="card-data">
                                    <div className="card-number">{statistics?.roles.role_num}</div>
                                </div>
                                <div className="card-label">Total active roles</div>
                            </div>
                            <div className="card-rate">{statistics?.roles.stat}</div>
                        </div>

                    </div>
                </div>
                <div className="w-full flex flex-col gap-2 p-2 bg-white shadow">
                    <div className="flex gap-2 w-full justify-center items-center">
                        <div className="relative">
                            <input type="text" value={positionSearch} onChange={
                                (e)=>{
                                    setPositionSearch(e.target.value);
                                    setShowAll(false);
                                }} className='text-box' placeholder="Search position title...." />
                            <div onClick={()=>setPositionSearch('')} className={positionSearch !== '' ? "absolute top-2 right-2 cursor-pointer" : "hidden"}>
                                <FontAwesomeIcon className="text-red-500" icon={faTimes} />
                            </div>
                        </div>
                        <div className="ms-auto flex items-center gap-2">
                            <div className={!filteredRoles.some(role => role.checked === true) ? "hidden" : 'flex gap-2 w-48'}>
                                {archiveBtnLoading ? (
                                    <button type="button" className="button button-vcc-yellow text-xs cursor-not-allowed bg-yellow-500 w-18 px-1">
                                        <FontAwesomeIcon icon={faSpinner} className="animate-spin" />
                                    </button>
                                ) : (
                                    <button type="button" onClick={handleSoftDel} className="button button-vcc-yellow text-xs w-18 px-1">
                                        <FontAwesomeIcon icon={faBoxArchive} />&nbsp;
                                        archive
                                    </button>
                                )}
                                
                                {fileDownloading ? (
                                    <button type="button" className="button button-vcc-green text-sm cursor-not-allowed bg-green-400">
                                        <FontAwesomeIcon icon={faSpinner} className="animate-spin" />
                                    </button>
                                ): (
                                    <button type="button" onClick={handleDownloadCsv} className="button button-vcc-green text-xs w-28 px-1">
                                        <FontAwesomeIcon icon={faFileArrowDown} /> &nbsp; csv
                                    </button>
                                )}
                               
                            </div>
                            <div className="floating-card-container">
                                <button onClick={()=>handleCloseFloatCard(1)} className="flex items-center gap-2 border border-gray-400 px-2 py-1 rounded shadow bg-gray-50">
                                    <input type="checkbox" checked={false} className="check-box cursor-pointer" />
                                    <p>Available segments</p>
                                </button>
                                <div ref={_divFloatCard} className={showAvailSeg ? "floating-card" : "hidden"}>
                                    <div className="floating-card-header">
                                        <div className="text-sm underline flex items-center gap-2">
                                            <FontAwesomeIcon icon={faCheck} className="text-green-600" />
                                            <button onClick={()=>handleSelectAllSeg(true)} className="cursor-pointer hover:text-blue-500 duration-100">
                                                Select All
                                            </button>
                                        </div>
                                        <div className="text-sm underline flex items-center gap-2">
                                            <FontAwesomeIcon icon={faTimes} className="text-red-500" />
                                            <button onClick={()=>handleSelectAllSeg(false)} className="cursor-pointer hover:text-blue-500 duration-100">
                                                Deselect All
                                            </button>
                                        </div>
                                    </div>
                                    <div className="floating-card-body">
                                        {segments && segments.length > 0 ? segments.map((seg)=>(
                                            <div className="flex gap-2 my-2 items-center border-b hover:bg-gray-100">
                                                <input type="checkbox" checked={seg.checked} onChange={(e)=>selectSeg(seg.seg, e)} className="check-box cursor-pointer" />
                                                <small>{seg.seg}</small>
                                            </div>
                                        )) : (
                                            <div>
                                                No segment available
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="floating-card-container">
                                <button onClick={()=>handleCloseFloatCard(2)} className="flex items-center gap-2 border border-gray-400 px-2 py-1 rounded shadow bg-gray-50">
                                    <input type="checkbox" checked={false} className="check-box cursor-pointer" />
                                    <p>Available sub-segments</p>
                                </button>
                                <div ref={divFloatCard} className={showAvailSubSeg ? "floating-card" : "hidden"}>
                                    <div className="floating-card-header">
                                        <div className="text-sm underline flex items-center gap-2">
                                            <FontAwesomeIcon icon={faCheck} className="text-green-600" />
                                            <button onClick={()=>handleSelectAllSubSeg(true)} className="cursor-pointer hover:text-blue-500 duration-100">
                                                Select All
                                            </button>
                                        </div>
                                        <div className="text-sm underline flex items-center gap-2">
                                            <FontAwesomeIcon icon={faTimes} className="text-red-500" />
                                            <button onClick={()=>handleSelectAllSubSeg(false)} className="cursor-pointer hover:text-blue-500 duration-100">
                                                Deselect All
                                            </button>
                                        </div>
                                    </div>
                                    <div className="floating-card-body">
                                        {subSegments && subSegments.length > 0 ? subSegments.map((seg)=>(
                                            <div className="flex gap-2 my-2 items-center border-b hover:bg-gray-100">
                                                <input type="checkbox" checked={seg.checked} onChange={(e)=>selectSubSeg(seg.seg, e)} className="check-box cursor-pointer" />
                                                <small>{seg.seg}</small>
                                            </div>
                                        )) : (
                                            <div>
                                                No sub-segment available
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div>
                                <button  onClick={()=>allRoles.current?.click()} className="flex items-center gap-2 border border-gray-400 px-2 py-1 rounded shadow bg-gray-50">
                                    <input type="checkbox" ref={allRoles} checked={showAll} onChange={(e)=>{
                                        setLoading(true);
                                        setShowAll(e.currentTarget.checked);
                                        setPositionSearch('');
                                        }} className="check-box cursor-pointer" />
                                    <p>Show all roles</p>
                                </button>
                            </div>
                            <div className="flex gap-4 text-xl text-gray-700">
                                <div>
                                    <button className="hover:text-orange-500" onClick={decrementYear}>
                                        <FontAwesomeIcon icon={faAngleLeft} />
                                    </button>
                                </div>
                                <div>
                                    {year ? year : currentYear}
                                </div>
                                <div>
                                    <button className="hover:text-orange-500" onClick={incrementYear}>
                                        <FontAwesomeIcon icon={faAngleRight} />
                                    </button>
                                </div>
                            </div>
                            <div className="flex gap-4 w-40 text-xl text-gray-700">
                                <div>
                                    <button onClick={decrementMonth} className="hover:text-orange-500">
                                        <FontAwesomeIcon icon={faAngleLeft} />
                                    </button>
                                </div>
                                <div className="w-24 text-center">
                                    {months[month]}
                                </div>
                                <div className="ms-auto">
                                    <button onClick={incrementMonth} className="hover:text-orange-500">
                                        <FontAwesomeIcon icon={faAngleRight} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="table-container h-full">
                            <table className="w-full h-full border">
                                <thead className="table-fixed-header border">
                                    <tr className="bg-gray-100">
                                        <th className='table-headers font-medium'>
                                            <input type="checkbox" 
                                             checked={filteredRoles.every(role => role.checked === true)}
                                             onChange={(e)=>setFilteredRoles(filteredRoles.map(role => ({...role, checked : e.target.checked})))}
                                             className="check-box cursor-pointer" />
                                        </th>
                                        <th className='table-headers font-medium'>Clients</th>
                                        <th className='table-headers font-medium'>Position Title</th>
                                        <th className='table-headers font-medium'>Status</th>
                                        <th className='table-headers font-medium'>FTE</th>
                                        <th className='table-headers font-medium'>Budget</th>
                                        <th className='table-headers font-medium'>Action</th>
                                    </tr>
                                </thead>
                                <tbody className="text-center">
                                    {!loading ? (
                                        filteredRoles.length > 0 ? (
                                            filteredRoles.map((role, index) => (
                                                <tr className="hover:bg-gray-300" key={index}>
                                                    <td className='table-body px-2'>
                                                        <input type="checkbox" checked={role.checked} onChange={
                                                            (e)=>setFilteredRoles(filteredRoles.map((r) => 
                                                                r.id === role.id ? {...r, checked : e.target.checked} : r
                                                            ))
                                                            } className="check-box cursor-pointer" />
                                                    </td>
                                                    <td className='table-body px-2'>{role.client_name}</td>
                                                    <td className='table-body px-2 mx-4'>{role.position_title}</td>
                                                    <td className='table-body px-2'>
                                                        <p className={
                                                            role.status === 'Open' ?
                                                            "text-xs rounded text-white card-stat-green" :
                                                            role.status === 'Closed' ?
                                                            "text-xs rounded text-white card-stat-red" :
                                                            role.status === 'On Hold' ?
                                                            "text-xs rounded text-white card-stat-warning" :
                                                            "text-xs rounded text-white card-stat-blue"
                                                        }>
                                                            {role.status}
                                                        </p>
                                                    </td>
                                                    <td className='table-body px-2'>{role.fte}</td>
                                                    <td className='table-body px-2'>{role.budget}</td>
                                                    <td className='table-body px-2'>
                                                        <div className='flex justify-center items-center'>
                                                            <a href={`/requirements/details/${role.id}/${encodeURIComponent(role.client_name)}/${encodeURIComponent(role.position_title)}`} rel="noopener noreferrer" target="_blank" className="cursor-pointer text-blue-500 font-normal text-md hover:underline">
                                                                View role details &nbsp;
                                                                <FontAwesomeIcon icon={faMagnifyingGlass} />
                                                            </a>
                                                            {/* <p onClick={()=>createModalContent(<ViewRequirememtsDetails id={role.id} />)} className="cursor-pointer text-blue-500 font-normal text-md hover:underline">
                                                                View role details &nbsp;
                                                                <FontAwesomeIcon icon={faMagnifyingGlass} />
                                                            </p> */}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={7} className='table-body px-2'>No role found.</td>
                                            </tr>
                                        )
                                    ) : (
                                        <>
                                            {[...Array(3)].map((_, rowIndex) => (
                                                <tr key={rowIndex}>
                                                    {[...Array(7)].map((_, colIndex) => (
                                                        <td key={colIndex} className='table-body'>
                                                            <div className="table-loading"></div>
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </>
                                    )}
                                </tbody>
                            </table>    
                        </div>
                        <div>
                            <div className="text-gray-700 my-2">
                                <p>
                                    Showing {filteredRoles.length} roles out of {monthRoles.length}.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showModal &&(
                <Modal onClose={()=>setShowModal(false)}> 
                    {modalChildren}
                </Modal>
            )}
        </div>
    );
}